import React from 'react';
import { css } from 'aphrodite';
import styles from './manage-drivers-styles';
import { ContentCard, ContentRow } from '../common';


const ManageDrivers = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Manage drivers'}>
      <ContentRow>
        Here would be a list of drivers to manage (admin only)
      </ContentRow>
    </ContentCard>
  </div>
);

export default ManageDrivers;



// WEBPACK FOOTER //
// ./src/components/manage-drivers/manage-drivers.js